import { HashRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Pillars from "@/pages/Pillars";
import Methods from "@/pages/Methods";
import Assessment from "@/pages/Assessment";
import Benchmarks from "@/pages/Benchmarks";
import FocusAreas from "@/pages/FocusAreas";

export default function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pillars" element={<Pillars />} />
          <Route path="/methods" element={<Methods />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/benchmarks" element={<Benchmarks />} />
          <Route path="/focus" element={<FocusAreas />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}
